import { getOrderForOrderStatus } from "@bevco/Services/OrderService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
  chain,
  RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";

replaceInChain(chain, RequestDataFromApi, async props => {
  try {
    props.apiResult = await getOrderForOrderStatus(props.apiParameter);
  } catch (error) {
      if (error.status === 404) {
          props.parameter.onError?.(error.errorMessage);
          return;
      }
      throw error;
  }
});
